module.exports = __webpack_public_path__ + "static/media/controlBoxes.7af0e4e7.jpg";